module.exports = __webpack_public_path__ + "img/zhengshu3.ed8d09cc.png";